const openModalBanner = () => {
    $(function () {
        $("#banner-modal").modal("show");
    });
};

const closeModalBanner = () => {
    const buttonClose = $("#btn-close-banner-modal");

    buttonClose.on("click", function () {
        $("#banner-modal").modal("hide");
    });
};

const calculateTotalBanner = () => $("#banner .swiper-slide").length;

const bannerSlider = () => {
    new Swiper(".banner-slider", {
        speed: calculateTotalBanner() > 1 ? 1000 : 0,
        loop: true,
        centeredSlides: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        slidesPerView: "auto",
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        allowTouchMove: false,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
        },
    });
};

const handleDetailBanner = () => {
    const buttonDetail = $("#btn-detail-banner");
    const listHrefBanner = $("#banner-modal .swiper-slide");
    let href = listHrefBanner[listHrefBanner.length - 1].attributes.href.value;

    setInterval(() => {
        href = changeHref(href, listHrefBanner);
    }, 3000);

    buttonDetail.on("click", function () {
        window.location.href = href;
        $("#banner-modal").modal("hide");
        href = listHrefBanner[listHrefBanner.length - 1].attributes.href.value;
    });
};

const changeHref = (currentHref, listHref) => {
    for (let i = 0; i < listHref.length; i += 1) {
        if (listHref[i].attributes.href.value == currentHref) {
            if (i + 1 < listHref.length) {
                return listHref[i + 1].attributes.href.value;
            } else {
                return listHref[0].attributes.href.value;
            }
        }
    }
};

module.exports = {
    openModalBanner,
    closeModalBanner,
    bannerSlider,
    handleDetailBanner,
};
